module.exports = __webpack_public_path__ + "img/navLogo.0e751c05.png";